import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "@/components/landing/shared";

export const Faq = () => (
  <section id="faq" className="border-t border-zinc-900 py-24 sm:py-32">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal>
        <SectionLabel index="06" testid="faq-label">
          FAQ
        </SectionLabel>
        <h2 className="mt-6 font-display text-3xl font-bold leading-none tracking-tight sm:text-5xl">
          Questions, answered.
        </h2>
      </Reveal>

      <Reveal delay={0.05}>
        <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-zinc-900">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left text-base font-medium text-white hover:text-zinc-300 hover:no-underline sm:text-lg"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-zinc-400">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
